export enum LicenseType {
  Core = 'core',
  Tool = 'tool',
  Feature = 'feature',
}
